import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { filter } from 'rxjs/operators';
import { environment as env } from '../../../environments/environment';

declare const gtag: any; // Declare ga as a function

@Injectable()
export class AnalyticsService {
    private enabled: boolean;

    constructor(private location: Location, private router: Router) {
        this.enabled = env.environment === 'prod';
    }

    trackPageViews() {
        if (this.enabled) {
            this.router.events
                .pipe(filter(event => event instanceof NavigationEnd))
                .subscribe((event: NavigationEnd) => {
                    gtag('config', 'UA-149661050-2', {
                        page_path: event.urlAfterRedirects
                    });
                    gtag('send', 'pageview', this.location.path());
                });
        }
    }

    trackEvent(eventName: string) {
        if (this.enabled) {
            gtag('send', 'event', eventName);
        }
    }

    public gaEvent(eventAction: string, eventCategory: string, eventLabel: string = null, eventValue: number = null) {
        // https://developers.google.com/analytics/devguides/collection/gtagjs/events
        if (this.enabled) {
            gtag('event', eventAction, {
                event_category: eventCategory,
                event_label: eventLabel,
                value: eventValue
            });
        }
    }
}
